import { createListenerMiddleware } from "@reduxjs/toolkit";
import { AppDispatch } from "../store";
import { getPagedJobs, mergeJobs } from "../actions/jobActions";
import { GetJobsListQuery } from "../model/jobModel";

const jobMiddleware = createListenerMiddleware();

jobMiddleware.startListening({
    actionCreator: mergeJobs.fulfilled,
    effect: (action, listenerApi) => {
        listenerApi.cancelActiveListeners();
        const state = (listenerApi.getState() as RootState);
        
        (listenerApi.dispatch as AppDispatch)(getPagedJobs({
            pageIndex: 0,
            pageSize: state.job.jobsPage.pageSize,
            searchTerm: ""
        } as GetJobsListQuery));             
    }
});


export default jobMiddleware.middleware;